<template>
  <v-row class="flex-nowrap align-center" :class="classRow">
    <v-col
      cols="auto"
      class="d-flex justify-start align-center user-post__div-avatar flex-shrink-0"
      :class="isComment ? 'user-post__comment-margin' : ''"
      v-if="!isJournal && !isSurveyMonkey"
    >
      <div class="user-post__avatars" v-if="!isHeaderImage">
        <v-avatar
          :size="isComment ? '32' : '40'"
          :class="currentUser"
          @click="showModalImage"
        >
          <img :src="item.profileImage" />
        </v-avatar>

        <v-avatar
          v-for="(company, index) in collabProfiles"
          :key="company.id || index"
          :size="isComment ? '32' : '40'"
          class="user-post__avatar-collab"
        >
          <img :src="company.profileImage" />
        </v-avatar>
      </div>
      <v-avatar
        v-if="!isHeaderImage && item.blockedType === 'BLOCKED'"
        size="14"
        :class="
          isComment
            ? 'user-post__blocked-icon-comment'
            : 'user-post__blocked-icon'
        "
      >
        <SvgIcon name="blocked" color="white" />
      </v-avatar>
      <v-avatar
        v-if="
          item.profileMedalType &&
          !isHeaderImage &&
          item.blockedType !== 'BLOCKED'
        "
        size="22"
        :class="
          isComment
            ? 'user-post__interactionMedal-comment'
            : 'user-post__interactionMedal'
        "
      >
        <img :src="imgInteractionLevel(item, 'timeline')" />
      </v-avatar>
    </v-col>
    <v-col
      cols="auto"
      class="user-post__text pl-4"
      :class="spaceRepost"
      v-if="!isJournal && !miniSidebar && !isSurveyMonkey"
    >
      <div v-if="!isHeaderImage">
        <p class="mb-0 d-inline-flex" :class="classNameText">
          {{ namePost }}
        </p>
        <img
          src="@/assets/medal.svg"
          class="pl-1 user-post__medal-img"
          v-if="item.hasMedal"
        />
      </div>
      <p
        class="mb-0"
        :class="classCompanyText"
        v-if="!isHeaderImage && collabProfiles.length > 0"
      >
        {{ $t("post.postedBy") }} <strong>{{ item.name }}</strong>
      </p>
      <p
        class="mb-0"
        :class="classCompanyText"
        v-if="
          !['MARKETING', 'FOUR_NETWORK'].includes(item.role) && !isHeaderImage
        "
      >
        {{ item.companyName }}
      </p>
    </v-col>
    <v-col cols="10" v-if="isSurveyMonkey">
      <v-row class="d-none d-sm-flex">
        <v-col
          cols="auto"
          v-if="
            (me.role === 'FOUR_NETWORK' || me.role === 'PARTICIPANT') &&
            pointsSurveyMonkey > 0
          "
        >
          <div class="carousel-survey__points d-flex align-center px-3 py-1">
            <SvgIcon name="coin" color="purple100" />
            <span class="ml-2 carousel-survey__points-text">{{
              pointsLabel(pointsSurveyMonkey)
            }}</span>
          </div>
        </v-col>
        <v-col
          cols="auto"
          class="d-flex align-center"
          :class="
            me.role === 'FOUR_NETWORK' || me.role === 'PARTICIPANT'
              ? 'pl-2'
              : ''
          "
        >
          <p class="white--text body-2 mb-0">
            {{ $t("misc.availableUntil") }}
            <span class="subtitle-1">{{ deadlineSurveyMonkey }}</span>
          </p>
        </v-col>
        <v-col cols="12">
          <p class="white--text text-start text-h6 mt-3 mb-0">
            {{ titleSurveyMonkey }}
          </p>
        </v-col>
      </v-row>
      <v-row class="d-flex d-sm-none">
        <v-col
          cols="auto"
          class="mb-3"
          v-if="me.role === 'FOUR_NETWORK' && pointsSurveyMonkey > 0"
        >
          <div class="carousel-survey__points d-flex align-center px-3 py-1">
            <SvgIcon name="coin" color="purple100" />
            <span class="ml-2 carousel-survey__points-text">{{
              pointsLabel(pointsSurveyMonkey)
            }}</span>
          </div>
        </v-col>
        <v-col cols="auto" class="d-flex align-center">
          <p class="white--text body-2 mb-3">
            {{ $t("misc.availableUntil") }}
            <span class="subtitle-1">{{ deadlineSurveyMonkey }}</span>
          </p>
        </v-col>
        <v-col cols="12">
          <p class="white--text text-start text-h6 mb-0">
            {{ titleSurveyMonkey }}
          </p>
        </v-col>
      </v-row>
    </v-col>
    <v-spacer />
    <v-col
      cols="auto"
      class="flex-shrink-0 d-flex align-center"
      :class="classDivButton"
      v-if="!isDebate && !isSidebar && !isInvite && !hideButton && !readonly"
    >
      <p
        class="mb-0 gray70--text label pr-0 d-inline-flex"
        :class="isMostCommentJournal ? 'white--text' : 'gray70--text'"
      >
        {{ creationDate }}
      </p>
      <BaseButton
        type-button="tertiary"
        text
        v-html="follow ? $t('profile.influencer') : '+ ' + $t('profile.follow')"
        v-if="canFollow"
        @click="$emit('follow')"
      />
      <v-menu bottom offset-y left v-if="!sameUserMostComment">
        <template v-slot:activator="{ on }">
          <BaseButton
            type-button="tertiary"
            :class="classButton"
            v-on="on"
            svg-icon-name="menu_vert"
            :is-dark-context="isSurveyMonkey || isJournal"
          />
        </template>
        <OptionsPost
          :profile="item"
          :is-post="isPost"
          :is-comment="isComment"
          :can-fixed="canFixed"
          :is-repost="isRepost"
          :is-read="isRead"
          :is-white-paper="isWhitePaper"
          :show-original="showOriginal"
          :is-community="isCommunity"
          :can-fix-mention="canFixMention"
          :can-fix-case="canFixCase"
          :is-success-case="isSuccessCase"
          :tab-case="tabCase"
          :is-modal="isModal"
          :can-make-visible="canMakeVisible"
          @open="openModal"
          :is-most-comment="isMostComment"
          :fixes="fixes"
          :is-survey-monkey="isSurveyMonkey"
          :tab-mention="tabMention"
        />
      </v-menu>
      <ModalImageProfile
        v-model="modalImage"
        v-if="modalImage"
        @close="closeModalImage"
        :profile="item"
      />
    </v-col>
  </v-row>
</template>
<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import OptionsPost from "./OptionsPost.vue";
import ModalImageProfile from "../../../components/modal/ModalImageProfile.vue";
import { ModalMixin } from "../../../mixins/ModalMixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
import { formatDatePost } from "@/utils/format";
import { MedalMixin } from "@/mixins/MedalMixin";
import { State } from "vuex-class";
@Component({
  components: {
    OptionsPost,
    ModalImageProfile,
  },
})
export default class UserPost extends mixins(ModalMixin, MedalMixin) {
  @Prop(Object) item: any;
  @Prop({ default: false }) isSmall: boolean;
  @Prop({ default: false }) readonly: boolean;
  @Prop({ default: false }) hideButton: boolean;
  @Prop({ default: false }) isModal: boolean;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) isPost: boolean;
  @Prop({ default: false }) isComment: boolean;
  @Prop({ default: false }) canFixed: boolean;
  @Prop({ default: false }) isTable: boolean;
  @Prop({ default: false }) isRepost: boolean;
  @Prop({ default: false }) userRepost: boolean;
  @Prop({ default: false }) postRepost: boolean;
  @Prop({ default: false }) isRead: boolean;
  @Prop({ default: false }) isHeaderImage: boolean;
  @Prop(Object) commentItem: any;
  @Prop(String) commentType: string;
  @Prop({ default: false }) isWhitePaper: boolean;
  @Prop({ default: false }) showOriginal: boolean;
  @Prop({ default: false }) isCommunity: boolean;
  @Prop({ default: false }) isInvite: boolean;
  @Prop({ default: false }) isJournal: boolean;
  @Prop({ default: false }) canFollow: boolean;
  @Prop({ default: false }) follow: boolean;
  @Prop({ default: false }) isRoundTable: boolean;
  @Prop({ default: false }) canFixMention: boolean;
  @Prop({ default: false }) canMakeVisible: boolean;
  @Prop({ default: false }) isSuccessCase: boolean;
  @Prop({ default: false }) newPost: boolean;
  @Prop({ default: false }) canFixCase: boolean;
  @Prop({ default: false }) tabCase: boolean;
  @Prop(String) creationDate: string;
  @Prop({ default: false }) isMostComment: boolean;
  @Prop({ default: false }) isSidebar: boolean;
  @Prop({ default: false }) miniSidebar: boolean;
  @Prop({ default: false }) isDebate: boolean;
  @Prop({ default: false }) sameUserMostComment: boolean;
  @Prop({ default: () => [] }) fixes: any;
  @Prop({ default: false }) isMostCommentJournal: boolean;
  @Prop({ default: false }) isSurveyMonkey: boolean;
  @Prop({ default: "" }) deadlineSurveyMonkey: string;
  @Prop({ default: 0 }) pointsSurveyMonkey: number;
  @Prop({ default: "" }) titleSurveyMonkey: string;
  @Prop({ default: false }) tabMention: boolean;
  @Prop({ default: () => [] }) collabProfiles: Array<any>;
  show = false;
  modalImage = false;
  formatDatePost = formatDatePost;
  @State((state) => state.profile.me) me: any;
  get classDivButton(): string {
    return this.isHeaderImage
      ? "d-flex justify-end align-start user-post__col pr-4"
      : this.isJournal
      ? "ml-5 user-post__col"
      : this.isSurveyMonkey
      ? "d-flex justify-end align-start"
      : "d-flex justify-end align-center user-post__col";
  }
  get classButton(): string {
    return this.isHeaderImage
      ? "px-0 footer-background user-post__button-with-background"
      : "px-0 user-post__button justify-center";
  }
  get currentUser(): string {
    return this.item.role === "PARTICIPANT"
      ? "user-post__avatar-green"
      : this.item.role === "EXECUTIVE"
      ? "user-post__avatar-red"
      : this.item.role === "EQUIPE"
      ? "user-post__avatar-black"
      : this.item.role === "PARTNER"
      ? "user-post__avatar-blue"
      : this.isComment
      ? "user-post__company-profile-comment"
      : "user-post__company-profile";
  }
  get sizeAvatar(): string {
    return this.isInvite || this.isTable || this.isSidebar
      ? "auto"
      : this.isSmall
      ? "2"
      : "1";
  }
  get sizeText(): string {
    return this.isInvite || this.isTable || this.isSidebar
      ? "10"
      : this.userRepost
      ? "8"
      : "9";
  }
  get classOptions(): string {
    return this.isModal
      ? "user-post__card-fixed"
      : this.isWhitePaper
      ? "user-post__card-white-paper"
      : this.isJournal
      ? "user-post__card-journal"
      : "user-post__card";
  }
  get spaceRepost(): string {
    return this.isTable
      ? "text-end text-sm-start user-post__space-table"
      : this.postRepost
      ? "user-post__space-repost"
      : "";
  }
  get classRow(): string {
    if (this.isJournal) return "";
    const table = this.isTable
      ? "user-post__min-size-table d-flex justify-start text-start pb-3"
      : "user-post__min-size pb-3";
    return this.newPost
      ? ""
      : this.isHeaderImage
      ? `user-post__min-height ${table}`
      : `${table}`;
  }
  get classNameText(): string {
    const sizeText = this.isComment ? "label" : "subtitle-1";
    const color =
      (((this.$route.name === "profileHome" &&
        this.me.role !== "FOUR_NETWORK") ||
        (this.$route.name === "timelineFourNetworkSection" &&
          this.me.role === "FOUR_NETWORK")) &&
        this.isSidebar) ||
      this.isMostCommentJournal
        ? "white--text"
        : "gray90--text";
    // const padding = ["MARKETING", "FOUR_NETWORK"].includes(this.item.role)
    //   ? "pt-2"
    //   : "";
    return `${sizeText} ${color}`;
  }
  get namePost(): string {
    if (!this.collabProfiles || this.collabProfiles.length === 0) {
      return this.item.name;
    }

    const firstCompany = this.collabProfiles[0]?.name;

    if (this.collabProfiles.length === 1) {
      return firstCompany;
    }

    const others = this.collabProfiles.length - 1;

    return `${firstCompany} ${this.$tc("post.andOtherCompanies", others, {
      count: others,
    })}`;
  }
  get classCompanyText(): string {
    const sizeText = this.isComment ? "caption" : "body-2";
    const color =
      ((this.$route.name === "profileHome" ||
        (this.$route.name === "timelineFourNetworkSection" &&
          this.me.role === "FOUR_NETWORK")) &&
        this.isSidebar) ||
      this.isMostCommentJournal
        ? "white--text"
        : "gray70--text";
    return `${sizeText} ${color}`;
  }
  openModal(action: string): void {
    if (_.isEmpty(this.commentItem)) {
      this.$emit("open", action);
    } else {
      const emit = {
        type: action,
        item: this.commentItem,
        typeComment: this.commentType,
      };
      this.$emit("openComment", emit);
    }
  }
  showOptions(): void {
    this.show = true;
    setTimeout(() => {
      this.show = false;
    }, 5000);
  }
  showModalImage(): void {
    this.blockScroll();
    this.modalImage = true;
  }
  closeModalImage(): void {
    this.unblockScroll();
    this.modalImage = false;
  }
  pointsLabel(item: number): string {
    const value = Number(item || 0);
    return `${value} ${this.$t("profile.points")}`;
  }
}
</script>
<style lang="sass">
.user-post__
  &col
    position: relative
    @media (min-width:360px) and (max-width:430px)
      margin-left: 8px
  &button
    min-width: unset !important
    width: unset !important
    height: unset !important
    padding: 0 !important
    display: flex !important
    align-items: center !important
    justify-content: center !important
    .svg-icon
      margin-right: 0 !important
  &button-with-background
    height: 40px !important
    min-width: 40px !important
    border-radius: 0 0 4px 4px !important
  &card
    position: absolute
    min-width: 300px !important
    z-index: 99
    top: 40px
    @media(min-width: 1264px)
      left: 60px
  &card-white-paper
    position: absolute
    min-width: 270px !important
    z-index: 99
    top: 40px
    @media(max-width: 1264px)
      right: 0
  &avatars
    display: flex
    align-items: center

  &avatar-collab
    width: 40px !important
    min-width: 40px !important
    height: 40px !important

    margin-left: -10px
    overflow: hidden
    border-radius: 16px !important
    flex-shrink: 0

    img
      width: 100%
      height: 100%
      object-fit: cover
      border-radius: 16px !important

    &:first-child
      margin-left: 0
  &text
    min-width: 0
    flex-shrink: 1
    @media(min-width: 1264px)
      left: 30px
  &card-fixed
    position: absolute
    min-width: 300px !important
    z-index: 99
    top: 40px
    right: 0
  &card-journal
    position: absolute
    min-width: 300px !important
    z-index: 99
    top: 40px
    @media(min-width: 1264px)
      left: 45px
    @media(max-width: 1264px)
      right: 0
  &text
    min-width: 0
    flex-shrink: 1
    overflow: hidden
    @media (min-width:360px) and (max-width:430px)
      margin-left: -8px
    > div
      display: flex !important
      align-items: center
      min-width: 0
      overflow: hidden
      > p
        flex: 0 1 auto
        min-width: 0
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
    > p
      min-width: 0
      max-width: 100%
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
  &space-table
    @media (min-width:360px) and (max-width:430px)
      max-width: 175px !important
  &space-repost
    @media (max-width:390px)
      margin-left: 2px !important
  &min-size
    min-width: 170px !important
  &min-size-table
    min-width: 170px !important
    @media (min-width:1264px)
      min-width: 300px !important
  &min-height
    min-height: 79px !important
  &medal-img
    flex-shrink: 0
  &interactionMedal
    position: absolute
    margin-top: -25px
    margin-left: 25px
  &interactionMedal-comment
    position: absolute
    margin-top: -17px
    margin-left: 17px
  &div-avatar
    position: relative
  &comment-margin
    @media (min-width:600px)
      margin-right: -8px !important
  &company-profile
    border-radius: 16px !important
  &company-profile-comment
    border-radius: 12px !important
  &avatar-green
    border: 2px solid var(--v-greenCLevel-base) !important
    border-radius: 22px !important
  &avatar-red
    border: 2px solid var(--v-redExecutive-base) !important
    border-radius: 22px !important
  &avatar-black
    border: 2px solid var(--v-black-base) !important
    border-radius: 22px !important
  &avatar-blue
    border: 2px solid var(--v-bluePartner-base) !important
    border-radius: 22px !important
  &blocked-icon
    position: absolute
    margin-bottom: -25px
    margin-left: 28px
  &blocked-icon-comment
    position: absolute
    margin-bottom: -18px
    margin-left: 20px

.v-application .user-post__text > div > p
  display: block !important
</style>
